import { listBannerKits, type BannerKit } from './banner-kit-api';
import { useAdLibrary, type UseAdLibrary } from './hooks/useAdLibrary';

/** The job kinds that write onto a kit: a generation run fills its size grid shape by shape, and a layer
 *  decomposition adds a shape's layers. Module-level so the hook's options stay stable. */
const BANNER_KIT_JOB_KINDS: readonly string[] = ['banner_kit', 'kit_layers'];

/** A brand's banner kits, kept fresh while a kit's runs land (see {@link useAdLibrary}). */
export const useBannerKitLibrary = (tenantId?: number): UseAdLibrary<BannerKit> =>
  useAdLibrary<BannerKit>(tenantId, { list: listBannerKits, doneKinds: BANNER_KIT_JOB_KINDS });
